function addToCartVariant(id) {
                let formData = {
                               id: id,
                               quantity: 1,
                              };
                $.ajax({
                   url: '/cart/add',
                   type: 'POST',
                   data: formData,
                  success: function(response){
                    $.ajax({
                      url: '/?section_id=cart-drawer',
                      type: 'GET',
                      dataType: 'html',
                      success: function(carthtml){
                         $('.drawer').addClass('animate active');
                         $('cart-drawer').html($(carthtml).find('cart-drawer').html());
                         bubbleUpdate();
                         $('cart-drawer').removeClass('is-empty');
                      }
                    })
                  }
                });
                    function bubbleUpdate() {
                      fetch(window.Shopify.routes.root + 'cart.js')
                             .then(response => response.json())
                             .then(data => {
                                  $('.cart-count-bubble').text(data.item_count);
                               });
                       }
            }






